import apiClient from "@utils/axios.utils";

export interface Contact {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string;
    subject: string;
    message: string;
    isRead: boolean;
    isArchived: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface ContactFormData {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string;
    subject: string;
    message: string;
}

export const createContact = async (
    contact: ContactFormData
): Promise<Contact> => {
    try {
        const response = await apiClient.post<Contact>("/contacts", contact);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création du contact :", error);
        throw error;
    }
};